'use strict';

const Mn = require('backbone.marionette');
const GanttView = require('balus/ui/view/body/project/content/gantt');
// const SearchView = require('balus/ui/view/body/project/content/search');
const Template = require('balus/ui/template/body/project/content/index.hbs');
// const Marked = require('balus/util/marked');

module.exports = Mn.View.extend({
    template: Template,
    regions: {
        gantt: '.project-gantt-wrapper',
        search: '.project-search-container'
    },

    onRender: function() {
        const context = this.getOption('context');

        this.showChildView('gantt', new GanttView({
            model: this.model,
            context: context
        }));

        /*
        const groupId = context.getGroup().get('id');
        const isProduction = context.getAppInfo().isProduction(groupId);
        if (!isProduction) {
            this.showChildView('search', new SearchView({
                model: this.model,
                context: context,
                marked: (new Marked())
            }));
        }
        */
    },

    startGanttEditMode: function() {
        this.getChildView('gantt').startEditMode();
    },

    endGanttEditMode: function() {
        this.getChildView('gantt').endEditMode();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/content/index.js